import { FC } from 'react';
import { DATE_SORT_RADIO_OPTIONS } from './configs';
import { IDateSortRadioGroupProps } from './types';
import { Radio } from 'antd';

const DateSortRadioGroup: FC<IDateSortRadioGroupProps> = ({ onDateSortChange, onChange, ...props }) => {
	// ! render
	return (
		<Radio.Group
			size='small'
			optionType='button'
			options={DATE_SORT_RADIO_OPTIONS}
			onChange={(e) => {
				onDateSortChange?.(e.target.value);
				onChange?.(e);
			}}
			{...props}
		/>
	);
};

export default DateSortRadioGroup;
